
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_mgja0_5d8ai_93",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_mgja0_5d8ai_1",
  "root": "awsui_root_mgja0_5d8ai_120",
  "trigger-wrapper": "awsui_trigger-wrapper_mgja0_5d8ai_132",
  "trigger-flexbox": "awsui_trigger-flexbox_mgja0_5d8ai_136",
  "preferred-wordbreak": "awsui_preferred-wordbreak_mgja0_5d8ai_140",
  "one-grid": "awsui_one-grid_mgja0_5d8ai_148",
  "calendar-header": "awsui_calendar-header_mgja0_5d8ai_151",
  "calendar-header-months-wrapper": "awsui_calendar-header-months-wrapper_mgja0_5d8ai_157",
  "calendar-header-month": "awsui_calendar-header-month_mgja0_5d8ai_157",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_mgja0_5d8ai_177",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_mgja0_5d8ai_180",
  "calendar-day-names": "awsui_calendar-day-names_mgja0_5d8ai_183",
  "calendar-day-name": "awsui_calendar-day-name_mgja0_5d8ai_183",
  "calendar-week": "awsui_calendar-week_mgja0_5d8ai_198",
  "first-grid": "awsui_first-grid_mgja0_5d8ai_203",
  "second-grid": "awsui_second-grid_mgja0_5d8ai_204",
  "grid": "awsui_grid_mgja0_5d8ai_208",
  "date-and-time-wrapper": "awsui_date-and-time-wrapper_mgja0_5d8ai_212",
  "date-and-time-wrapper__date": "awsui_date-and-time-wrapper__date_mgja0_5d8ai_216",
  "date-and-time-wrapper__time": "awsui_date-and-time-wrapper__time_mgja0_5d8ai_219",
  "date-and-time-constrainttext": "awsui_date-and-time-constrainttext_mgja0_5d8ai_223",
  "footer": "awsui_footer_mgja0_5d8ai_230",
  "has-clear-button": "awsui_has-clear-button_mgja0_5d8ai_237",
  "footer-button-wrapper": "awsui_footer-button-wrapper_mgja0_5d8ai_244",
  "icon-wrapper": "awsui_icon-wrapper_mgja0_5d8ai_248",
  "label": "awsui_label_mgja0_5d8ai_253",
  "label-enabled": "awsui_label-enabled_mgja0_5d8ai_258",
  "label-text": "awsui_label-text_mgja0_5d8ai_262",
  "mode-switch": "awsui_mode-switch_mgja0_5d8ai_267",
  "dropdown": "awsui_dropdown_mgja0_5d8ai_271",
  "dropdown-content": "awsui_dropdown-content_mgja0_5d8ai_287",
  "start-date-input": "awsui_start-date-input_mgja0_5d8ai_296",
  "start-time-input": "awsui_start-time-input_mgja0_5d8ai_297",
  "end-date-input": "awsui_end-date-input_mgja0_5d8ai_298",
  "end-time-input": "awsui_end-time-input_mgja0_5d8ai_299",
  "validation-section": "awsui_validation-section_mgja0_5d8ai_303",
  "validation-error": "awsui_validation-error_mgja0_5d8ai_307",
  "clear-button": "awsui_clear-button_mgja0_5d8ai_311",
  "apply-button": "awsui_apply-button_mgja0_5d8ai_315",
  "cancel-button": "awsui_cancel-button_mgja0_5d8ai_319",
  "calendar-aria-live": "awsui_calendar-aria-live_mgja0_5d8ai_323"
};
  